'use strict';

var joinPath = function(base, path) {
  if (base.indexOf('http') === -1) {
    if (window.location.protocol.indexOf('https') !== -1) {
      base = 'https://' + base;
    } else {
      base = 'http://' + base;
    }
  }
  return base.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
};

var AuthConfig = function (sbAuthProvider) {

  var initData = window.document.querySelector('#init-data');
  var config = initData && JSON.parse(initData.getAttribute('value'));
  var authApi = config.authApi;
  sbAuthProvider.authBaseUrl = joinPath(authApi.url, authApi.basePath);
  sbAuthProvider.authPath = '/login';
  sbAuthProvider.authGooglePath = '/google';
  sbAuthProvider.authFacebookPath = '/facebook';
  sbAuthProvider.forgotPasswordPath = '/forgot-password';
  sbAuthProvider.resetPasswordPath = '/reset-password';
  sbAuthProvider.requestAccountPath = '/request-account';
  sbAuthProvider.authRefreshPath = '/refresh';
  sbAuthProvider.setOrganizationPath = '/set-organization';

};

module.exports = AuthConfig;



// WEBPACK FOOTER //
// ./src/common/auth/AuthConfig.js